export const isPhonePolarPartialSession = (session) =>
    session?.status === 'failed' &&
    session?.has_phone_upload === true &&
    session?.has_heartrate_upload === true &&
    session?.has_movepro_upload === false

export const canOpenSession = (session, { isAdmin = false } = {}) =>
    !!session?.id &&
    (session.status === 'processed' ||
        session.status === 'validation' ||
        isPhonePolarPartialSession(session) ||
        isAdmin)

// The reader is one of the session's owners (the Session resource's `owners`),
// not only allowed to edit it as an admin.
export const isSessionOwner = (session, userId) =>
    !!userId && (session?.owners ?? []).some((owner) => String(owner?.id) === String(userId))

// A tap on a session that opens asks « C'est bien ça ? » instead of showing its page
// (ModalsGroup): only who may edit it confirms it, never a failed one.
export const opensConfirmation = (session) => !!session?.canEdit && session?.status !== 'failed' && !session?.validated

// The reader is asked to confirm this session: it was read (never a failed or
// unprocessed one) and a tap on it asks « C'est bien ça ? ». The card dot (SessionCard),
// the banner (sessionsToConfirm) and the session page read this one rule, so the banner
// counts exactly the dots on screen.
export const asksToConfirm = (session) =>
    ['processed', 'validation'].includes(session?.status) && opensConfirmation(session)

// P7: the sessions of the events listed that ask their reader to confirm them, latest
// first: the banner counts them and opens the first.
export const sessionsToConfirm = (events) =>
    (events ?? [])
        .map((event) => (event?.model === 'session' ? event.session : null))
        .filter((session) => !!session?.id && asksToConfirm(session))
        .sort((a, b) => new Date(b.start_at) - new Date(a.start_at))
